import {RxJsonSchema} from 'rxdb';

export const FormsSchema: RxJsonSchema | any = {
    "version": 1,
    "type": "object",
    "title": "App Forms",
    "properties": {
        "key": {
            "type": "string",
            "primary": true,
            "final": true
        },
        "title": {
            "type": "string"
        },
        "description": {
            "type": "string"
        },
        "done": {
            "type": "boolean"
        },
        "doneDate": {
            "type": ["string", "null"]
        },
        "lastModifiedDate": {
            "type": ["string", "null"]
        },
        "form": {
            "type": "array",
            "items": {
                "type": "object"
            }
        }
    }
};
